module.exports = __webpack_public_path__ + "static/productCategoryImage-9c149afa3d794aa9f8e58ad79a466598.png";